import React from "react";
import ProjectContainer from "./Container.jsx";

function ProjectsSection({ title, two }) {
  return <ProjectContainer two={two} title={title} />;
}
export default ProjectsSection;
